"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_slick_1 = __importDefault(require("react-slick"));
var modal_1 = __importDefault(require("../../../../plugins/modal"));
var quick_add_on_card_1 = __importDefault(require("../../../account-v3/components/quick-add-on-card"));
var group_variants_for_cart_add_1 = __importDefault(require("../../../bundler/group-variants-for-cart-add"));
var api_1 = require("../../api");
var bundle_components_1 = __importDefault(require("../../bundle-components"));
var callout_1 = require("../../components/callout");
var essentials_bundle_editor_1 = __importDefault(require("../../components/essentials-bundle-editor"));
var inline_loader_1 = __importDefault(require("../../components/inline_loader"));
var link_block_1 = __importDefault(require("../../components/link-block"));
var loading_modal_1 = __importDefault(require("../../components/loading-modal"));
var vitamin_bundle_editor_1 = __importDefault(require("../../components/vitamin-bundle-editor"));
var fetch_quick_add_ons_1 = __importDefault(require("../../fetch-quick-add-ons"));
var delete_one_time_item_1 = require("../../mutations/delete-one-time-item");
var GenerateBrightbackCancellation = __importStar(require("../../mutations/initiate-brightback-cancellation"));
var update_subscription_1 = require("../../mutations/update-subscription");
var record_snack_time_event_1 = require("../../record-snack-time-event");
var utils_1 = require("../../utils");
var cancel_subscription_1 = __importDefault(require("../cancel-subscription"));
var index_1 = __importDefault(require("../orders/index"));
var bundle_editor_1 = __importDefault(require("./components/bundle-editor"));
var bundle_items_1 = __importDefault(require("./components/bundle-items"));
var discount_code_1 = __importDefault(require("./components/discount-code"));
var edit_child_1 = __importDefault(require("./components/edit-child"));
var frequency_1 = __importDefault(require("./components/frequency"));
var name_bundle_alert_1 = __importDefault(require("./components/name-bundle-alert"));
var next_ship_date_1 = __importDefault(require("./components/next-ship-date"));
var pricing_details_1 = __importDefault(require("./components/pricing-details"));
var shipping_address_1 = __importDefault(require("./components/shipping-address"));
exports.default = (function (_a) {
    var _b, _c;
    var groupedSubscription = _a.groupedSubscription, customerData = _a.customerData, singleBundleUser = _a.singleBundleUser, bundlerPreSelections = _a.bundlerPreSelections, onEditBundleModalClose = _a.onEditBundleModalClose, onSubscriptionUpdated = _a.onSubscriptionUpdated;
    var _d = __read((0, react_1.useState)(), 2), openDrawer = _d[0], setOpenDrawer = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), isCancelling = _e[0], setIsCancelling = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), displayHelloBelloCancelExperience = _f[0], setDisplayHelloBelloCancelExperience = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), isEditingBundle = _g[0], setIsEditingBundle = _g[1];
    var _h = __read((0, react_1.useState)(), 2), diaperBundleDirectStep = _h[0], setDiaperBundleDirectStep = _h[1];
    var _j = __read((0, react_1.useState)(false), 2), isLoadingQuickAddOns = _j[0], setIsLoadingQuickAddOns = _j[1];
    var _k = __read((0, react_1.useState)(false), 2), isAddingQuickAddOn = _k[0], setIsAddingQuickAddOn = _k[1];
    var _l = __read((0, react_1.useState)(), 2), preSelectedBundleType = _l[0], setPreSelectedBundleType = _l[1];
    var _m = __read((0, react_1.useState)(undefined), 2), quickAddOns = _m[0], setQuickAddOns = _m[1];
    var _o = __read((0, react_1.useState)(0), 2), numQuickAddOns = _o[0], setNumQuickAddOns = _o[1];
    var _p = __read((0, react_1.useState)(), 2), cancelReason = _p[0], setCancelReason = _p[1];
    var editChildRef = (0, react_1.useRef)(null);
    var quickAddOnsEnabled = window.accountApp.settings.quickAddOnsEnabled;
    var discountAddOnsPerLimit = ((_b = window.bundlerApp) === null || _b === void 0 ? void 0 : _b.discountAddOnsPerLimit) || 5;
    var diaperBundleTypes = ['Diaper', 'Training Pant'];
    (0, react_1.useEffect)(function () {
        // initialize foundation once
        new Foundation.Equalizer($('[data-equalizer]'));
    }, []);
    (0, react_1.useEffect)(function () {
        // pop the edit bundle modal immediately if a bundlerPreSelections prop was passed
        if (bundlerPreSelections) {
            handleEditBundle(bundlerPreSelections.directStep, { preSelectedBundleType: bundlerPreSelections.bundleType })();
        }
    }, [bundlerPreSelections]);
    (0, react_1.useEffect)(function () {
        // re-apply equalizer if the number quick add-ons changes
        Foundation.reflow($('[data-equalizer]'));
    }, [numQuickAddOns]);
    var queryClient = (0, react_query_1.useQueryClient)();
    var callout = (0, callout_1.useCallout)().callout;
    var _q = (0, react_query_1.useMutation)(function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_subscription_1.UPDATE_SUBSCRIPTION, variables); }, {
        onSuccess: function (updates) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.setQueryData('getCustomerSubscriptions', function (data) { return (0, update_subscription_1.updateSubscriptionCache)(data, updates); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    }), updateSubscription = _q.mutateAsync, error = _q.error;
    var generateBrightbackSessionUrlMutation = (0, react_query_1.useMutation)('generateBrightbackSessionUrl', function (variables) {
        return (0, api_1.getSubscriptionAPIClient)().request(GenerateBrightbackCancellation.GENERATE_BRIGHTBACK_CANCELLATION, variables);
    });
    var fetchBrightbackSessionUrlAndRedirectToIt = function () { return __awaiter(void 0, void 0, void 0, function () {
        var website, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    website = "".concat(window.location.protocol, "//").concat(window.location.hostname);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, generateBrightbackSessionUrlMutation.mutateAsync({
                            subscriptionId: subscription.id,
                            bundleType: translateBundleComponentsBundleTypeToSubApiApplyDiscountSaveToSubscriptionBundleType(bundleType),
                            saveReturnUrl: "".concat(website, "/account#/subscriptions/edit-items/").concat(subscription.id, "?bbd=ao"),
                            nevermindReturnUrl: "".concat(website, "/account#/subscriptions/edit-items/").concat(subscription.id, "?bbd=n"),
                            cancelConfirmationUrl: "".concat(website, "/account#/?bbd=c&sub=").concat(subscription.id),
                        })];
                case 2:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    // if it errors, we know it should be hellobello cancel flow
                    setDisplayHelloBelloCancelExperience(true);
                    return [2 /*return*/];
                case 4:
                    // if the mutation generated a Brightback session url, send the user to it
                    window.location.href = response.generateBrightbackSessionUrl.url;
                    return [2 /*return*/];
            }
        });
    }); };
    var _r = (0, react_query_1.useMutation)(function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(delete_one_time_item_1.DELETE_ONE_TIME_ITEM, variables); }, {
        onSuccess: function (updates) {
            queryClient.setQueryData('getCustomerSubscriptions', function (data) {
                var _a = data, getSubscriptions = _a.getSubscriptions, rest = __rest(_a, ["getSubscriptions"]);
                return __assign(__assign({}, rest), { getSubscriptions: updates.deleteOneTimeItem });
            });
        },
    }), deleteOneTimeItemMutation = _r.mutateAsync, isDeletingOneTimeMutation = _r.isLoading, deleteOneTimeError = _r.error;
    var handleCancelSubscription = function () {
        setIsCancelling(true);
        (0, utils_1.hideThirdPartyButtons)();
        return fetchBrightbackSessionUrlAndRedirectToIt();
    };
    var recordNevermindDeflectionInSnacktime = function () {
        return (0, record_snack_time_event_1.recordSnackTimeAction)(record_snack_time_event_1.Label.CANCELLATION_DEFLECTED, groupedSubscription.subscription.id, {
            deflectionType: record_snack_time_event_1.DeflectionType.NEVERMIND,
            reason: cancelReason === null || cancelReason === void 0 ? void 0 : cancelReason.title,
        });
    };
    var handleEditBundle = function (bundlerStep, opts) { return function () {
        // used to determine what bundle type should be chosen by default in the bundler app
        var preSelectedBundleType = opts === null || opts === void 0 ? void 0 : opts.preSelectedBundleType;
        if (preSelectedBundleType) {
            setPreSelectedBundleType(preSelectedBundleType);
        }
        var baseUrl = "".concat(subscriptionUrl, "/").concat(subscription.id);
        if (bundlerStep) {
            // we only need to set the direct diaper bundle step if working with diaper bundles
            if (diaperBundleTypes.includes(bundleType))
                setDiaperBundleDirectStep(bundlerStep);
            else if (bundleType === 'Vitamin')
                window.location.href = "".concat(baseUrl, "/").concat(bundlerStep);
        }
        // fundamentals bundles have only one step and will just fall here by default
        setIsEditingBundle(true);
        (0, utils_1.hideThirdPartyButtons)();
    }; };
    var subscription = (0, react_1.useMemo)(function () { return groupedSubscription.subscription; }, [groupedSubscription]);
    var bundleComponents = (0, react_1.useMemo)(function () { return new bundle_components_1.default(groupedSubscription); }, [groupedSubscription]);
    var _s = bundleComponents.getComponents(), diaperBundleItems = _s.diaperBundleItems, extraItems = _s.extraItems, vitaminBundleItems = _s.vitaminBundleItems, essentialsBundleItems = _s.essentialsBundleItems, onetimeItems = _s.onetimeItems;
    var numSubscriptionAddOns = (0, react_1.useMemo)(function () { return extraItems.reduce(function (acc, curr) { return acc + curr.quantity; }, 0); }, [extraItems]);
    // for naming vitamin bundles; if we ever add new variant sizes for vitamins, we'll want to add its name here as well
    var planNames = [
        { size: '3', name: 'Starter Plan' },
        { size: '5', name: 'Personal Plan' },
        { size: '7', name: 'Family Plan' },
    ];
    var bundleType = bundleComponents.getBundleType();
    var shouldHideDiaperOptions = (0, utils_1.isNonDiaperBundleType)(bundleType);
    var formattedBundleType = bundleType.toLowerCase().replace(' ', '_');
    var searchTerm = window.location.search;
    var subscriptionBaseName = singleBundleUser ? '/edit-bundle' : "/subscriptions/edit-items";
    // used for Bundle Editors routes; passes along args in links
    var subscriptionUrl = "/account".concat(searchTerm, "#").concat(subscriptionBaseName);
    var quickAddOnSliderSettings = {
        dots: false,
        arrows: false,
        centerMode: true,
        slidesToShow: 3,
        infinite: quickAddOns && quickAddOns.length > 3,
        responsive: [
            {
                breakpoint: 2560,
                settings: {
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 1110,
                settings: {
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    slidesToShow: 1,
                },
            },
        ],
    };
    var getEligibleAddOns = function (addOns) {
        // first, de-dupe the addOns
        var deDupedAddOns = addOns.reduce(function (acc, curr) {
            var variant = acc.find(function (addOn) { return addOn.variants[0].id === curr.variants[0].id; });
            return variant ? acc : acc.concat([curr]);
        }, []);
        // then, eligible quick add-on offers are ones whose variants are not already selected
        var selectedAddOnIds = groupedSubscription.children.map(function (child) { return child.shopify_variant_id; });
        var alreadySelected = function (quickAddOn) { return quickAddOn.variants.some(function (variant) { return selectedAddOnIds.includes(variant.id); }); };
        return deDupedAddOns.filter(function (quickAddOn) { return !alreadySelected(quickAddOn); });
    };
    var removeOneTime = function (item) {
        if (confirm("Are you sure you want to remove ".concat(item.title, "?")) && item.id)
            deleteOneTimeItemMutation({ id: item.id });
    };
    var fetchQuickAddOnsData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var mainBundleSize, patternProductTitles, children, sizesToFetch, bundleSizes, data, eligibleQuickAddOns;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsLoadingQuickAddOns(true);
                    mainBundleSize = (_a = subscription.variant) === null || _a === void 0 ? void 0 : _a.option1;
                    patternProductTitles = ['Bundle Diaper Patterns', 'Bundle Training Pant Patterns', 'Bundle Training Pant Patterns (Mixed)', 'Nighttime Diaper Patterns'];
                    children = groupedSubscription.children // coddle typescript
                    ;
                    sizesToFetch = diaperBundleTypes.includes(bundleType) && mainBundleSize
                        ? children.reduce(function (acc, curr) {
                            var _a;
                            // go through all the patterns to get their sizes because mainBundleSize could be mixed
                            if (patternProductTitles.includes(curr.product_title) && ((_a = curr.variant) === null || _a === void 0 ? void 0 : _a.option1)) {
                                acc.push(curr.variant.option1);
                            }
                            return acc;
                        }, [])
                        : undefined;
                    bundleSizes = sizesToFetch ? __spreadArray([], __read(new Set(sizesToFetch)), false) : sizesToFetch;
                    return [4 /*yield*/, (0, fetch_quick_add_ons_1.default)(formattedBundleType, bundleSizes)];
                case 1:
                    data = _b.sent();
                    eligibleQuickAddOns = getEligibleAddOns(data);
                    setQuickAddOns(eligibleQuickAddOns);
                    setNumQuickAddOns(eligibleQuickAddOns.length);
                    setIsLoadingQuickAddOns(false);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (!quickAddOnsEnabled) {
            return;
        }
        var diaperBundleUnderAddOnsLimit = diaperBundleTypes.includes(bundleType) && numSubscriptionAddOns < discountAddOnsPerLimit;
        // don't fetch quick add-ons if we're editing a Vitamin Bundle or if we're editing a Diaper/Training Pant Bundle that already has 5 add-ons
        if (!quickAddOns && (bundleType === 'Fundamentals' || diaperBundleUnderAddOnsLimit)) {
            fetchQuickAddOnsData();
        }
    }, [subscription]);
    var processAddQuickAddOnToBundle = function () { return function (quickAddOn) { return __awaiter(void 0, void 0, void 0, function () {
        var bundleId, mainSubProperties, childProperties, extrasProperties_1, mainSub, extras, newAddOns, newBundle, itemUpdates, variantIds;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsAddingQuickAddOn(true);
                    bundleId = (_a = subscription.properties.find(function (_a) {
                        var name = _a.name;
                        return name === 'bundle_id';
                    })) === null || _a === void 0 ? void 0 : _a.value;
                    if (!(bundleId || groupedSubscription.manager === 'recharge')) return [3 /*break*/, 2];
                    mainSubProperties = groupedSubscription.manager === 'hellobello' && bundleId ? { bundle_id: bundleId } : {};
                    childProperties = groupedSubscription.manager === 'hellobello' && bundleId ? { parent_bundle_id: bundleId } : {};
                    extrasProperties_1 = groupedSubscription.manager === 'hellobello' && bundleId ? { parent_bundle_id: bundleId } : {};
                    mainSub = [subscription.shopify_variant_id, { properties: mainSubProperties }];
                    extras = groupedSubscription.children.map(function (child) { return [child.shopify_variant_id, { properties: extrasProperties_1, quantity: child.quantity }]; });
                    newAddOns = (0, group_variants_for_cart_add_1.default)(quickAddOn.variants, childProperties).map(function (item) { return item.createItemParams; });
                    newBundle = __spreadArray(__spreadArray([mainSub], __read(extras), false), __read(newAddOns), false);
                    itemUpdates = (0, utils_1.convertItemsToItemUpdateInputs)(newBundle);
                    return [4 /*yield*/, updateSubscription({ itemUpdates: itemUpdates, subscriptionId: subscription.id })];
                case 1:
                    _b.sent();
                    variantIds = quickAddOn.variants.map(function (_) { return _.id; });
                    (0, record_snack_time_event_1.recordSnackTimeAction)('AddQuickAddOn', subscription.id, { bundleType: bundleType, variantIds: variantIds });
                    callout.success('Successfully Updated Bundle! (Refresh page to reflect pricing changes)');
                    _b.label = 2;
                case 2:
                    setIsAddingQuickAddOn(false);
                    return [2 /*return*/];
            }
        });
    }); }; };
    var shouldOfferQuickAddOns = (function () {
        var _a;
        if (((_a = groupedSubscription.address) === null || _a === void 0 ? void 0 : _a.country) === 'Canada')
            return false;
        // Fundamentals Bundle has no item limit
        if (bundleType === 'Fundamentals') {
            return quickAddOns === null || quickAddOns === void 0 ? void 0 : quickAddOns.length;
        }
        return (quickAddOns === null || quickAddOns === void 0 ? void 0 : quickAddOns.length) && numSubscriptionAddOns < discountAddOnsPerLimit;
    })();
    var bundleItems = (function () {
        switch (bundleType) {
            case 'Vitamin':
                return vitaminBundleItems;
            case 'Fundamentals':
                return essentialsBundleItems;
            default:
                return diaperBundleItems;
        }
    })();
    var bundleEditor = (function () {
        switch (bundleType) {
            case 'Vitamin':
                return react_1.default.createElement(vitamin_bundle_editor_1.default, { existingBundle: groupedSubscription, subscriptionUrlLocation: subscriptionUrl, subscriptionBaseName: subscriptionBaseName });
            case 'Fundamentals':
                return react_1.default.createElement(essentials_bundle_editor_1.default, { existingBundle: groupedSubscription, subscriptionUrlLocation: subscriptionUrl, subscriptionBaseName: subscriptionBaseName });
            default:
                return (react_1.default.createElement(bundle_editor_1.default, { existingBundle: groupedSubscription, productId: subscription.shopify_product_id, subscriptionId: subscription.id, onComplete: function () { return setIsEditingBundle(false); }, directStep: diaperBundleDirectStep, preSelectedBundleType: preSelectedBundleType, subscriptionBaseName: subscriptionBaseName, subscriptionUrlLocation: subscriptionUrl, onSubscriptionUpdated: onSubscriptionUpdated }));
        }
    })();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(loading_modal_1.default, { error: error, isLoading: isAddingQuickAddOn, loadingText: 'Adding product to your bundle, please wait...' }),
        react_1.default.createElement(loading_modal_1.default, { error: deleteOneTimeError, isLoading: isDeletingOneTimeMutation, loadingText: 'Removing One-time item, please wait...' }),
        react_1.default.createElement("div", { className: 'padding-vertical-5' },
            shouldOfferQuickAddOns ? (react_1.default.createElement("div", { className: 'padding-bottom-10' },
                react_1.default.createElement("div", { className: 'font-bold account-header padding-bottom-3' },
                    react_1.default.createElement("img", { className: 'padding-right-3', src: window.accountApp.iconUrls.cart }),
                    react_1.default.createElement("span", null, window.accountApp.settings.quickAddOnsTitle)),
                react_1.default.createElement("div", { className: 'text-gray padding-bottom-3 padding-left-5' },
                    window.accountApp.settings.quickAddOnsSubtitle,
                    react_1.default.createElement("div", { className: 'display-inline padding-left-2 font-size-small' },
                        react_1.default.createElement("a", { className: 'text-wisteria text-underline', onClick: function () {
                                // if handling a diaper type bundle, redirect to discount add-ons step. otherwise, we should redirect to the beginning step
                                (0, utils_1.isNonDiaperBundleType)(bundleType) ? handleEditBundle()() : handleEditBundle('select-discount-add-ons')();
                            } }, (0, utils_1.isNonDiaperBundleType)(bundleType) ? 'See All Products' : 'See All Extras'))),
                react_1.default.createElement("div", { className: 'padding-horizontal-3', "data-equalizer": 'item' },
                    react_1.default.createElement(react_slick_1.default, __assign({}, quickAddOnSliderSettings), quickAddOns === null || quickAddOns === void 0 ? void 0 : quickAddOns.map(function (quickAddOn, i) { return (react_1.default.createElement(quick_add_on_card_1.default, { key: i, quickAddOnProduct: quickAddOn, processAddToBundle: processAddQuickAddOnToBundle(), bundleType: bundleType })); }))))) : (react_1.default.createElement(inline_loader_1.default, { isLoading: isLoadingQuickAddOns, loadingText: 'Searching for other awesome recommendations just for you!' })),
            (groupedSubscription === null || groupedSubscription === void 0 ? void 0 : groupedSubscription.bundleInfo) && false && react_1.default.createElement("div", { className: 'bg-light-wisteria margin-bottom-3 padding-3 border-wisteria' }, "Did you know you can name your bundle?"),
            react_1.default.createElement("div", { className: 'font-bold padding-bottom-5 account-header' },
                react_1.default.createElement("img", { className: 'padding-right-3', src: window.accountApp.iconUrls.shop }),
                singleBundleUser && groupedSubscription.bundleInfo ? "".concat(groupedSubscription.bundleInfo.name, "'s Bundle") : 'Bundle Content'),
            !groupedSubscription.bundleInfo && react_1.default.createElement(name_bundle_alert_1.default, { groupedSubscription: groupedSubscription, bundleType: bundleType, customerId: customerData === null || customerData === void 0 ? void 0 : customerData.id }),
            react_1.default.createElement("div", { className: 'account-container bg-white bordered border-very-light-pink' },
                shouldHideDiaperOptions ? (react_1.default.createElement(react_1.default.Fragment, null,
                    bundleType === 'Vitamin' && (react_1.default.createElement(link_block_1.default, { onClick: handleEditBundle(), header: 'Edit Your Plan', body: react_1.default.createElement("div", { className: 'cell font-size-12 text-brownish-grey' }, "".concat(((_c = planNames.find(function (_a) {
                            var size = _a.size;
                            return size === subscription.variant_title;
                        })) === null || _c === void 0 ? void 0 : _c.name) || '', " - ").concat(subscription.variant_title, " Bottles")), linkClassNames: 'solid-border-bottom rounded-top' })),
                    react_1.default.createElement(link_block_1.default, { onClick: bundleType === 'Vitamin' ? handleEditBundle('vitamins') : handleEditBundle(), header: bundleType === 'Vitamin' ? 'Vitamins' : 'Bundle Items', body: react_1.default.createElement(bundle_items_1.default, { openBundleEditor: bundleType === 'Vitamin' ? handleEditBundle('vitamins') : handleEditBundle(), items: bundleItems }), linkClassNames: 'rounded-top' }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(link_block_1.default, { onClick: handleEditBundle('select-size'), header: 'Bundle Settings', body: react_1.default.createElement("div", { className: 'cell font-size-12 text-brownish-grey' },
                            react_1.default.createElement("div", null,
                                bundleType,
                                " Bundle"),
                            react_1.default.createElement("div", null,
                                "Size ",
                                subscription.variant_title)), linkClassNames: 'solid-border-bottom rounded-top' }),
                    react_1.default.createElement(link_block_1.default, { onClick: handleEditBundle('select-prints'), header: 'Designs', body: react_1.default.createElement(bundle_items_1.default, { items: bundleItems, openBundleEditor: handleEditBundle('select-prints') }), linkClassNames: 'solid-border-bottom' }),
                    react_1.default.createElement(link_block_1.default, { onClick: handleEditBundle('select-discount-add-ons'), header: 'Your Extras', body: react_1.default.createElement(bundle_items_1.default, { items: extraItems, openBundleEditor: handleEditBundle('select-discount-add-ons') }) }))),
                onetimeItems.length > 0 && (react_1.default.createElement(link_block_1.default, { header: 'Your One-Time Items', body: react_1.default.createElement(bundle_items_1.default, { items: onetimeItems, openBundleEditor: handleEditBundle('select-discount-add-ons'), isOneTime: true, remove: function (item) { return removeOneTime(item); } }), linkClassNames: 'rounded-bottom' })),
                react_1.default.createElement("div", { className: 'panel', style: { border: 'none', marginTop: '-40px' } },
                    react_1.default.createElement(pricing_details_1.default, { groupedSubscription: groupedSubscription, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer }))),
            react_1.default.createElement("div", { className: 'font-bold padding-top-10 padding-bottom-5 account-header' },
                react_1.default.createElement("img", { className: 'padding-right-3', src: window.accountApp.iconUrls.store }),
                "Subscription Details"),
            react_1.default.createElement("div", { className: 'account-container' },
                react_1.default.createElement("div", { className: 'panel' },
                    react_1.default.createElement(frequency_1.default, { subscription: subscription, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, bundleType: bundleType }),
                    customerData && react_1.default.createElement(next_ship_date_1.default, { groupedSubscription: groupedSubscription, customerData: customerData, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer }),
                    react_1.default.createElement(shipping_address_1.default, { groupedSubscription: groupedSubscription, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer }),
                    customerData && react_1.default.createElement(discount_code_1.default, { groupedSubscription: groupedSubscription, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, customer: customerData }))),
            react_1.default.createElement("div", { className: 'margin-top-10 margin-bottom-5' },
                react_1.default.createElement(index_1.default, null)),
            react_1.default.createElement("div", { className: 'font-bold padding-top-10 padding-bottom-5 account-header' },
                react_1.default.createElement("img", { className: 'padding-right-3', src: shouldHideDiaperOptions ? window.accountApp.iconUrls.tag : window.accountApp.iconUrls.baby }),
                shouldHideDiaperOptions ? 'Personalize' : 'Child'),
            react_1.default.createElement("div", { className: 'account-container margin-bottom-3', ref: editChildRef },
                react_1.default.createElement("div", { className: 'panel' },
                    react_1.default.createElement(edit_child_1.default, { groupedSubscription: groupedSubscription, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, bundleInfo: groupedSubscription.bundleInfo, customerId: customerData === null || customerData === void 0 ? void 0 : customerData.id, bundleType: bundleType }))),
            react_1.default.createElement("button", { id: 'account-start-cancellation-btn' // for GA
                , onClick: handleCancelSubscription, className: 'account-bundles-container text-underline padding-top-10' }, "Cancel Subscription")),
        isCancelling && react_1.default.createElement(loading_modal_1.default, { error: undefined, isLoading: !displayHelloBelloCancelExperience }),
        react_1.default.createElement(modal_1.default, { isOpen: isCancelling && displayHelloBelloCancelExperience, handleClose: function () {
                setIsCancelling(false);
                (0, utils_1.showThirdPartyButtons)();
                recordNevermindDeflectionInSnacktime().catch(console.error);
            }, style: { content: { maxWidth: '600px' } } },
            react_1.default.createElement(cancel_subscription_1.default, { bundleType: bundleType, groupedSubscription: groupedSubscription, closeCancelModal: function () { return setIsCancelling(false); }, handleEditItems: handleEditBundle, reason: cancelReason, setReason: setCancelReason })),
        react_1.default.createElement(modal_1.default, { className: 'bundler-app-modal height-100', isOpen: isEditingBundle, handleClose: function () {
                setIsEditingBundle(false);
                console.debug("".concat(subscriptionUrl, "/").concat(subscription.id));
                // set the window to the edit bundle location to reset the editor after modal close
                window.location.href = singleBundleUser ? "/account".concat(searchTerm, "#") : "".concat(subscriptionUrl, "/").concat(subscription.id);
                (0, utils_1.showThirdPartyButtons)();
                if (onEditBundleModalClose)
                    onEditBundleModalClose().catch(console.error);
            } },
            react_1.default.createElement("div", { className: 'grid-y height-100' },
                react_1.default.createElement("div", { className: 'cell shrink padding-6 font-bold' }, "Edit Bundle"),
                react_1.default.createElement("div", { className: 'cell auto flex-container' }, bundleEditor)))));
});
var translateBundleComponentsBundleTypeToSubApiApplyDiscountSaveToSubscriptionBundleType = function (bundleType) {
    switch (bundleType) {
        case 'Diaper':
            return 'Diaper';
        case 'Fundamentals':
            return 'Fundamentals';
        case 'Training Pant':
            return 'TrainingPant';
        case 'Vitamin':
            return 'Vitamin';
    }
};
